export const ENTITY = 'user-management';
export const TEACHER_DIRECTORY_PATH = `${ENTITY}/teacher-directory`;
